import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ccb2a9d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccb2a9d')) {
      api.createRecord('4ccb2a9d', component.options)
    } else {
      api.reload('4ccb2a9d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ccb2a9d", function () {
      api.rerender('4ccb2a9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/index.vue"
export default component.exports